export default {

  required: {
    message : "Country in not set",
    fn      : (input)=>  Boolean(input)
  },

  min: {
    message : "Invalid country selected",
    fn      : (input)=>  input.length == 2
  }
}
